import * as React from 'react';

import PropTypes from 'prop-types';

import { color } from '@coursera/coursera-ui';

import { BUTTON_TYPES } from 'bundles/coursera-ui/components/basic/Button';
import SvgButton from 'bundles/coursera-ui/components/basic/SvgButton';
import withApiStatusUIInfo from 'bundles/coursera-ui/components/hocs/withApiStatusUIInfo';
import SvgCheckSolid from 'bundles/coursera-ui/components/svg/coursera/common/SvgCheckSolid';
import SvgCircleWarning from 'bundles/coursera-ui/components/svg/coursera/common/SvgCircleWarning';
import SvgLoaderSignal from 'bundles/coursera-ui/components/svg/coursera/common/SvgLoaderSignal';
import {
  API_BEFORE_SEND,
  apiStatusPropType,
  errorPropType,
} from 'bundles/coursera-ui/constants/apiNotificationConstants';

const SvgButtonWithApiStatus = withApiStatusUIInfo(SvgButton);

/**
 * A Button that handles ApiStatus changes.
 */
const ApiButton = ({
  apiStatus: apiStatusAlt,
  disableApiStatus,
  apiStatusAttributesConfig = {},
  apiStatusHtmlAttributesConfig = {},
  isThemeDark,
  children,
  style = {},
  type = 'secondary',

  iconAttributes = {
    size: 18,
  },

  ...rest
}: $TSFixMe) => {
  const apiStatus = disableApiStatus ? API_BEFORE_SEND : apiStatusAlt;

  const baseIconProps = {
    ...iconAttributes,
    isThemeDark,
  };

  const baseApiBtnStyle = { ...style, backgroundColor: 'transparent' };
  if (type === 'icon') {
    baseApiBtnStyle.borderColor = 'transparent';
  }

  return (
    <SvgButtonWithApiStatus
      apiStatus={apiStatus}
      isThemeDark={isThemeDark}
      type={type}
      apiStatusAttributesConfig={{
        style: {
          API_BEFORE_SEND: style,
          API_IN_PROGRESS: {
            color: isThemeDark ? color.disabledThemeDark : color.disabled,
            borderColor: isThemeDark ? color.disabledThemeDark : color.disabled,
            ...baseApiBtnStyle,
          },
          API_SUCCESS: {
            color: color.success,
            borderColor: color.success,
            ...baseApiBtnStyle,
          },
          API_ERROR: {
            color: color.danger,
            borderColor: color.danger,
            ...baseApiBtnStyle,
          },
        },
        svgElement: {
          API_BEFORE_SEND: children,
          API_IN_PROGRESS: <SvgLoaderSignal color={isThemeDark ? color.white : color.white} {...baseIconProps} />,
          API_SUCCESS: <SvgCheckSolid color={color.success} {...baseIconProps} />,
          API_ERROR: <SvgCircleWarning color={color.danger} {...baseIconProps} />,
        },
        ...apiStatusAttributesConfig,
      }}
      apiStatusHtmlAttributesConfig={{
        disabled: {
          API_BEFORE_SEND: false,
          API_IN_PROGRESS: true,
          API_SUCCESS: true,
          API_ERROR: true,
        },
        ...apiStatusHtmlAttributesConfig,
      }}
      {...rest}
    />
  );
};

ApiButton.propTypes = {
  // Default icon
  children: PropTypes.node,
  apiStatus: apiStatusPropType,
  disableApiStatus: PropTypes.bool,
  isThemeDark: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(BUTTON_TYPES)),
  apiStatusAttributesConfig: PropTypes.object,
  apiStatusHtmlAttributesConfig: PropTypes.object,
  iconAttributes: PropTypes.object,
  style: PropTypes.object,
};

export default ApiButton;

export { apiStatusPropType, errorPropType };
